export default __webpack_public_path__ + "static/22-400fc5db5e3fd2aa0b691fdb1fd68967.webp";